import styled from 'styled-components';
import {Point} from 'components/Project/styles';

export const FeaturedLinks = styled(Point)`
  line-height: 30px;
  & a {
    margin: 0 7px;
  }
`;


// WEBPACK FOOTER //
// ./src/components/projects/ShareSci/styles.js